export default {

	pc: {
		chinese: {
			//轮播图的数组
			carouselList: [{
					imagePath: require("@/images/home/12-0new1.png")
				},
				{
					imagePath: require("@/images/home/12-1.png")
				},
				{
					imagePath: require("@/images/home/12-2.png")
				},
				{
					imagePath: require("@/images/home/12-3new1.png")
				}
			],
			//新闻数据块数组
			dataConList: [{
					txt: "注册企业",
					img: require("@/images/home/1-3.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务核心企业",
					img: require("@/images/home/1-5.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务金融机构",
					img: require("@/images/home/1-6.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务覆盖100+二级行业",
					img: require("@/images/home/1-4.png"),
					suffix: "类",
					num: 0
				}
			],
			// 新闻标题
			newsTit: ['公司动态', '媒体报道', '行业资讯'],
			//查看更多
			more: 'More',
			//产品服务
			product: {
				detail:'查看详情',
				title: '产品服务',
				productList: [{
						title: "金单",
						img: require("@/images/home/1-11.png"),
						advantage: [{
								num: "特点一",
								tit: "易流转",
								icon: require("@/images/home/1-14.png"),
								txt: "可结合自身实际需求，匹配多种金单流转方式，优化现金管理、降低经营成本"
							},
							{
								num: "特点二",
								tit: "可拆分",
								icon: require("@/images/home/1-15.png"),
								txt: "金额随意拆，无任何手续费"
							},
							{
								num: "特点三",
								tit: "秒融资",
								icon: require("@/images/home/1-16.png"),
								txt: "网上操作，实时响应；无需纸质申请资料，随时办理随时变现"
							},
							{
								num: "特点四",
								tit: "可追溯",
								icon: require("@/images/home/1-17.png"),
								txt: "在线产生数据报表，流转全程可追溯"
							}
						],
						txt: "核心企业通过简单汇系统，以电子签名的方式，承诺在指定日期支付确定金额货款给供应商的，易流转、可拆分、秒融资、可追溯的应收账款债权凭证。"
					},
					{
						title: "供应链票据",
						img: require("@/images/home/1-13.png"),
						advantage: [{
								num: "特点一",
								tit: "操作便捷",
								icon: require("@/images/home/1-34.png"),
								txt: "供应链票据可灵活拆、转、融等，全流程均在供应链平台线上操作"
							},
							{
								num: "特点二",
								tit: "融资高效",
								icon: require("@/images/home/1-33.png"),
								txt: "供应链票据作为电子商票，融资渠道丰富，线上放款效率高"
							},
							{
								num: "特点三",
								tit: "成本优势",
								icon: require("@/images/home/1-36.png"),
								txt: "供应链票据签收、背书、到期等操作均为零费率，较传统票据融资成本低"
							},
							{
								num: "特点四",
								tit: "风控优势",
								icon: require("@/images/home/1-35.png"),
								txt: "供应链票据到期由票交所统一发起托收，自动到账；签发人有信用准入，回款安全"
							}
						],
						txt: "企业通过供应链平台在票交所的供应链票据系统开具的可等分化签发的电子商业汇票。"
					},
					{
						title: "微贷",
						img: require("@/images/home/1-12.png"),
						advantage: [{
								num: "特点一",
								tit: "产业服务",
								icon: require("@/images/home/1-37.png"),
								txt: "为核心企业产业链属中小微企业量身定制，产品和服务更懂实体经营"
							},
							{
								num: "特点二",
								tit: "全线上化",
								icon: require("@/images/home/1-40.png"),
								txt: "全流程纯线上化操作"
							},
							{
								num: "特点三",
								tit: "简单方便",
								icon: require("@/images/home/1-39.png"),
								txt: "两项资料，十分钟完成申请，平均三小时到账"
							},
							{
								num: "特点四",
								tit: "灵活好用",
								icon: require("@/images/home/1-38.png"),
								txt: "随借随还，按天计息，不用款零费用"
							}
						],
						txt: "微贷是简单汇基于产业知识图谱，深入分析产业机会，通过整合产业信息（IND）、小微企业信息（B）、企业主个人信息（C），发掘产业链上中小微企业自身的商业信用和金融信用能力，通过向中小微企业提供无抵押的纯信用线上融资服务，助力产业链协同发展。"
					},
					{
						title: "信用评级",
						img: require("@/images/home/1-60.png"),
						advantage: [{
								num: "特点一",
								tit: "实力雄厚",
								icon: require("@/images/home/1-61.png"),
								txt: "简单汇子公司广东恒诚信用管理有限公司于2014年成立，是向人行备案的全国55家有资质开展信用评级公司之一，也是简单汇产品服务的重要板块"
							},
							{
								num: "特点二",
								tit: "场景丰富",
								icon: require("@/images/home/1-62.png"),
								txt: "产品应用场景覆盖招投标、供应商准入、商业赊销、银行、小贷、保理、融租等金融机构企业授信，在全国主要地区均可线下或全线上手段开展各类评级"
							},
							{
								num: "特点三",
								tit: "科技加成",
								icon: require("@/images/home/1-63.png"),
								txt: "团队有用专业的分析师队伍及大数据研发人员，形成了科学智能的评级体系，通过数据服务、风控模型提供综合解决方案"
							},
							{
								num: "特点四",
								tit: "高质高效",
								icon: require("@/images/home/1-64.png"),
								txt: "团队拥有多年从业经验及各种成功的案例，能够以专业、高质、高效的方式为中小微企业提供优质评级服务"
							}
						],
						txt: "恒诚信用评级业务是通过收集企业主体或金融产品的各类信息，依据不断优化的评级方法和模型，评价企业主体或债务的偿债能力和偿债意愿，用信用评级报告的形式发布评级结果。"
					},
					{
						title: "票据秒融",
						img: require("@/images/home/1-55.png"),
						advantage: [{
								num: "特点一",
								tit: "秒级放款",
								icon: require("@/images/home/1-56.png"),
								txt: "一键询价，系统自动审批放款，真正实现秒级到账"
							},
							{
								num: "特点二",
								tit: "全程线上",
								icon: require("@/images/home/1-57.png"),
								txt: "全流程线上操作，无需线下跑银行开户，高效便捷"
							},
							{
								num: "特点三",
								tit: "免费询价",
								icon: require("@/images/home/1-58.png"),
								txt: "多家银行系统对接，报价实时更新，支持OCR识票并免费报询价"
							},
							{
								num: "特点四",
								tit: "节省成本",
								icon: require("@/images/home/1-59.png"),
								txt: "多家银行，同时询价择优贴现，节省时间和经济成本"
							}
						],
						txt: "持票企业可向银行发起线上签约、票据询价、预贴现或预质押等票据业务申请。"
					},

					{
						title: "汇科云",
						img: require("@/images/home/1-50.png"),
						advantage: [{
								num: "特点一",
								tit: "模式多样",
								icon: require("@/images/home/1-51.png"),
								txt: "品牌定制、单点登录、开放API、本地部署"
							},
							{
								num: "特点二",
								tit: "产品丰富",
								icon: require("@/images/home/1-52.png"),
								txt: "电子债权凭证系统、保理系统、供应链票据系统"
							},
							{
								num: "特点三",
								tit: "开放共享",
								icon: require("@/images/home/1-53.png"),
								txt: "资金方、中登网、第三方服务等优质资源共享"
							},
							{
								num: "特点四",
								tit: "科技加持",
								icon: require("@/images/home/1-54.png"),
								txt: "利用云计算、大数据、区块链、OCR、NLP、RPA、等技术打造的科技赋能产品"
							}
						],
						txt: "汇科云是科技赋能产品，为客户提供全方位供应链金融科技服务，帮助企业构建“科技+金融”的能力，为客户实现供应链金融与科技的生态融合。"
					},
				],
			},

			//平台优势
			advantages: {
				title: '简单汇平台优势',
				details: '查看详情',
				platformList: [
					//简单汇平台优势数组
					{
						title: "创新发展优势",
						img: require("@/images/home/1-18.png"),
						txt: "从市场首创可流转的应收账款电子债权凭证——金单； 到成为全国第一批直联上海票据交易所的票据基础设施单位，简单汇一直引领行业创新。"
					},
					{
						title: "科技领先优势",
						img: require("@/images/home/1-19.png"),
						txt: "简单汇率先应用区块链技术保障数据安全，成功通过国家高新技术企业认定、CMMI3及国家信息系统安全等级三级认证，不断完成技术升级与突破。"
					},
					{
						title: "产品服务优势",
						img: require("@/images/home/1-20.png"),
						txt: "简单汇致力于提供简单、温暖的客户服务体系，7*24全程专业服务，随时为您答疑解惑，伴随您业务发展的每一步。"
					},
					{
						title: "资金渠道优势",
						img: require("@/images/home/1-21.png"),
						txt: "简单汇首创与银行系统直连模式，先后与十余家全国性大行完成系统直联，并与多家知名财务公司、保理公司保持合作，充分发挥资金渠道优势。"
					},
					{
						title: "专业团队优势",
						img: require("@/images/home/1-22.png"),
						txt: "简单汇管理团队及核心骨干均具备丰富的“金融+科技+产业”行业背景，拥有十余年金融科技或金融行业从业经验，是一支多元化精英团队。"
					}
				],
			},
			//合作银行
			banks: {
				title: '合作银行'
			},
			//合作企业
			enterprises: {
				title: '合作企业'
			},
			//办公地点
			location: {
				title: '办公地点'
			}
		},
		english: {
			// 英文的轮播图数组
			carouselListYW: [{
					imagePath: require("@/images/english/12-4new1.png")
				},
				{
					imagePath: require("@/images/english/12-5.png")
				},
				{
					imagePath: require("@/images/english/12-6.png")
				},
				{
					imagePath: require("@/images/english/12-7new1.png")
				}
			],
			//新闻数据块数组英文
			dataConListYW: [{
					txt: "Registered enterprises",
					img: require("@/images/home/1-3.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Anchor enterprises served",
					img: require("@/images/home/1-5.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Financial institutions served",
					img: require("@/images/home/1-6.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Sectors served ·Including 100+ secondary sectors",
					img: require("@/images/home/1-4.png"),
					suffix: "",
					num: 0
				}
			],
			// 新闻标题
			newsTit: ['Company News', 'Media Reports', 'Industry Information'],
			//查看更多
			more: 'More',
			//产品服务
			product: {
				detail:'View details9',
				title: 'Product services',
				productListYW: [{
						title: "JinBill",
						img: require("@/images/home/1-11.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to circulate",
								icon: require("@/images/home/1-14.png"),
								txt: "Combining actual demands with multiple ways of Golden Bill circulation to optimize cash management and reduce operating costs"
							},
							{
								num: "Feature 2",
								tit: "Splittable",
								icon: require("@/images/home/1-15.png"),
								txt: "Financing split on demand and free of charge"
							},
							{
								num: "Feature 3",
								tit: "Instant financing",
								icon: require("@/images/home/1-16.png"),
								txt: "Online operation in instant response; dispensing with paper documents and withdrawing cash instantaneously"
							},
							{
								num: "Feature 4",
								tit: "Traceable",
								icon: require("@/images/home/1-17.png"),
								txt: "Online access to data reports, and full process traceable"
							}
						],
						txt: "JinBill refers to the creditor’s right certificate for accounts receivable that is easy to circulate, split, finance and trace. Based on the JinBill, the core enterprise promises to grant a certain amount of loans to suppliers on a specified date, through the JDH system by means of electronic signatures."
					},
					{
						title: "Supply Chain Bill",
						img: require("@/images/home/1-13.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to operate",
								icon: require("@/images/home/1-34.png"),
								txt: "Supply chain bills are easy to split, circulate and finance, with full process accessible online"
							},
							{
								num: "Feature 2",
								tit: "Efficient financing",
								icon: require("@/images/home/1-33.png"),
								txt: "As electronic commercial draft, supply chain bills boast abundant financing channels and high online funding efficiency"
							},
							{
								num: "Feature 3",
								tit: "Cost advantage",
								icon: require("@/images/home/1-36.png"),
								txt: "Zero service fee for supply chain bills receipts, endorsement and maturity processing; lower costs than traditional bill financing"
							},
							{
								num: "Feature 4",
								tit: "Risk control advantage",
								icon: require("@/images/home/1-35.png"),
								txt: "Due supply chain bills are collected by Shanghai Commercial Paper Exchange Corporation Ltd., with direct remittance; trust thresholds are set for issuers to ensure payment return"
							}
						],
						txt: "Supply chain bill refers to the electronic commercial bill issued by enterprises through the supply chain platform in the supply chain bill system of Shanghai Commercial Paper Exchange Corporation Ltd., which can be equally differentiated and issued."
					},
					{
						title: "WiCredit",
						img: require("@/images/home/1-12.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Industry services",
								icon: require("@/images/home/1-37.png"),
								txt: "Products and services customized for SMEs of the industrial chain of core enterprises; better understanding the real industry operation"
							},
							{
								num: "Feature 2",
								tit: "Full process online",
								icon: require("@/images/home/1-40.png"),
								txt: "Full process accessible online"
							},
							{
								num: "Feature 3",
								tit: "Easy and convenient",
								icon: require("@/images/home/1-39.png"),
								txt: "Two e-documents and ten minutes to complete an application, and only 3 hours on average to receive the fund"
							},
							{
								num: "Feature 4",
								tit: "Flexible and user friendly",
								icon: require("@/images/home/1-38.png"),
								txt: "Flexible to lend and return; interests counted daily; zero service fee if the fund is unused"
							}
						],
						txt: "WiCredit aims to explore the commercial and financial credit capabilities of the micro, small and medium-sized enterprises (MSMEs) in the industrial chain. It is based on the industrial knowledge map, in-depth analysis of industrial opportunities, and integration of industrial data (IND), small and micro enterprises information (B) and business owners' personal information (C). It promotes the coordinated development of the industrial chain by providing online credit financing services to MSMEs without collateral. "
					},
					{
						title: "Credit rating Service",
						img: require("@/images/home/1-60.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Strong Strength",
								icon: require("@/images/home/1-61.png"),
								txt: "Guangdong Hengcheng Credit Manage-ment Co.,Ltd.,a subsidiary of JDH,was established in 2014.It is one of the 55 qualified credit rating companies in the country that have been registered with the People’s Bank of China, and is also an important section of JDH’s prodicts and services"
							},
							{
								num: "Feature 2",
								tit: "Rich Scenarios",
								icon: require("@/images/home/1-62.png"),
								txt: "Product Application Scenarios cover Bidding,Supplier Access,Commercial Credit Sales,Banking, Small Loans, Fac-toring,Financial Leasing and financial Institution corporate credit. All kinds ofratings can be carried out offline or online in major regions of the country"
							},
							{
								num: "Feature 3",
								tit: "Technical",
								icon: require("@/images/home/1-63.png"),
								txt: "The team has a professional team of analysts and big data R&D personnel,forming a scientific and intelligent rating system,providing comprehensive solu-tions through data services and risk con-trol models"
							},
							{
								num: "Feature 4",
								tit: "High quality and efficienct",
								icon: require("@/images/home/1-64.png"),
								txt: "The team has many years of experi-ence and various successful cases,and can provide high-quality rating services for SMEs in a professional,high-quality and efficient way"
							}
						],
						txt: "The credit rating business of Hengcheng is to evaluate the solvency and wllingness to pay debts of corporate entities or debts based on the continuously optimized rating methods and models, by collecting various infor-mation about corporate entities or financial products,and publish the rating results in the form of credit rating reports.The rating results can be widely used for enter-prises to apply for various types of financing from finan-cial istitutions and various preferential policies of gov ernment institutions , and also display credit information to cooperative enterprises."
					},
					{
						title: "Bill financing in seconds",
						img: require("@/images/home/1-55.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Lending in seconds",
								icon: require("@/images/home/1-56.png"),
								txt: "One-click inquiry,the system auto-matically approves the loan,and truly realizes loan to the account in secounds"
							},
							{
								num: "Feature 2",
								tit: "All online",
								icon: require("@/images/home/1-57.png"),
								txt: "The whole process is operated online, and there is no need to go offline to open a bank account, which is efficient and convenient"
							},
							{
								num: "Feature 3",
								tit: "Free inquiry",
								icon: require("@/images/home/1-58.png"),
								txt: "Docking with multiple banking systems, quotations are updat-ed in real time, OCR bills recog-nition is supported, and free quotation"
							},
							{
								num: "Feature 4",
								tit: "Save cost",
								icon: require("@/images/home/1-59.png"),
								txt: "Multiple banks can be inquiring at the same time,discounting at the best, saving time and economic costs"
							}
						],
						txt: "Bill-holding compaies can initiate bill financ-ing applications such as online signing, bill inquiry,pre-discount or pre-pledge to the bank."
					},
					{
						title: "Hui cloud",
						img: require("@/images/home/1-50.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Diverse modes",
								icon: require("@/images/home/1-51.png"),
								txt: "Brand customization,single sign-on, open API,local deploy-ment"
							},
							{
								num: "Feature 2",
								tit: "Rich products",
								icon: require("@/images/home/1-52.png"),
								txt: "Creditor's rights electronic vouch-er system,factoring system,supply chain bill system"
							},
							{
								num: "Feature 3",
								tit: "Open and Shared",
								icon: require("@/images/home/1-53.png"),
								txt: "Sharing of high-quality resourc-es such as funders,Zhongdeng-wang and third-party services"
							},
							{
								num: "Feature 4",
								tit: "Technology blessing",
								icon: require("@/images/home/1-54.png"),
								txt: "Technology-enabled   prod-ucts using cloud computing,big data,block chain,OCR,NLP,RPA and other technolo-gies"
							}
						],
						txt: "Huike Cloud is a technology-enabled product that provides customers with a full range of supplychain financial technology services, helps compa-nies build 'Technology + Finance' capabilities, andrealizes the ecological integration of supply chainfinance and technology for customers."
					}
				],
			},
			//平台优势
			advantages: {
				title: 'Advantages of the JDH platform',
				details: 'View details',
				platformListYW: [{
						title: "Advantages of innovative development",
						img: require("@/images/home/1-18.png"),
						txt: "JDH has been leading the industry innovation from creating the first circulated electronic creditor’s right certificate for accounts receivable on the market – JinBill to becoming one of the first batch of bill infrastructure units directly connected to Shanghai Commercial Paper Exchange Corporation Ltd. in China."
					},
					{
						title: "Advantages of science and technology",
						img: require("@/images/home/1-19.png"),
						txt: "Having first applied blockchain technology to ensure data security, JDH has obtained the national high-tech enterprise certification as well as Level 3 certifications of Capability Maturity Model Integration (CMMI) and Level 3 certification of national information system security. JDH has been continuously pursuing technological upgrading and breakthroughs."
					},
					{
						title: "Advantages of services",
						img: require("@/images/home/1-20.png"),
						txt: "JDH is committed to providing a simple and warm customer service system where 7*24 professional services are provided to respond to your enquires. We will support you in every step of your business development."
					},
					{
						title: "Advantages of capital channels",
						img: require("@/images/home/1-21.png"),
						txt: "JDH first creates the model of direct connection with the banking systems. It has successively completed the direct connection with over ten national banks, and maintained cooperation with many well-known financial companies and factoring companies, thus giving full play to its advantages of capital channels."
					},
					{
						title: "Advantages of the professional team",
						img: require("@/images/home/1-22.png"),
						txt: "Making itself a diversified elite team, JDH management team as well as its core members boasts strong industry background of “finance + technology + industry” and rich working experience over ten years in financial technology or financial sector."
					}
				],
			},
			//合作银行
			banks: {
				title: 'Cooperative banks'
			},
			//合作企业
			enterprises: {
				title: 'Cooperative enterprises'
			},
			//办公地点
			location: {
				title: 'Office location'
			}
		}
	},
	phone: {
		chinese: {
			//轮播图的数组
			carouselList: [{
					imagePath: require("@/images/mobile/home/carousel-1new.jpg")
				},
				{
					imagePath: require("@/images/mobile/home/carousel-2.png")
				},
				{
					imagePath: require("@/images/mobile/home/carousel-3.png")
				},
				{
					imagePath: require("@/images/mobile/home/carousel-4new.jpg")
				}
			],
			//新闻块的数据数组
			dataConList: [{
					txt: "注册企业",
					img: require("@/images/home/1-3.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务核心企业",
					img: require("@/images/home/1-5.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务金融机构",
					img: require("@/images/home/1-6.png"),
					suffix: "家",
					num: 0
				},
				{
					txt: "服务覆盖100+二级行业",
					img: require("@/images/home/1-4.png"),
					suffix: "类",
					num: 0
				}
			],
			news: {
				more: '查看更多',
				//新闻分类
				slidingList: ["公司动态", "媒体报道", "行业资讯"],
			},
			//产品服务
			product: {
				title: '产品服务',
				productList: [{
						title: "金单",
						img: require("@/images/mobile/home/1-9.png"),
						advantage: [{
								num: "特点一",
								tit: "易流转",
								icon: require("@/images/home/1-14.png"),
								txt: "可结合自身实际需求，匹配多种金单流转方式，优化现金管理、降低经营成本"
							},
							{
								num: "特点二",
								tit: "可拆分",
								icon: require("@/images/home/1-15.png"),
								txt: "金额随意拆，无任何手续费"
							},
							{
								num: "特点三",
								tit: "秒融资",
								icon: require("@/images/home/1-16.png"),
								txt: "网上操作，实时响应；无需纸质申请资料，随时办理随时变现"
							},
							{
								num: "特点四",
								tit: "可追溯",
								icon: require("@/images/home/1-17.png"),
								txt: "在线产生数据报表，流转全程可追溯"
							}
						],
						txt: "核心企业通过简单汇系统，以电子签名的方式，承诺在指定日期支付确定金额贷款给供应商的，易流转、可拆分、秒融资、可追溯的应收账款债权凭证。"
					},
					{
						title: "供应链票据",
						img: require("@/images/mobile/home/1-10.png"),
						advantage: [{
								num: "特点一",
								tit: "操作便捷",
								icon: require("@/images/home/1-34.png"),
								txt: "供应链票据可灵活拆、转、融等，全流程均在供应链平台线上操作"
							},
							{
								num: "特点二",
								tit: "融资高效",
								icon: require("@/images/home/1-33.png"),
								txt: "供应链票据作为电子商票，融资渠道丰富，线上放款效率高"
							},
							{
								num: "特点三",
								tit: "成本优势",
								icon: require("@/images/home/1-36.png"),
								txt: "供应链票据签收、背书、到期等操作均为零费率，较传统票据融资成本低"
							},
							{
								num: "特点四",
								tit: "风控优势",
								icon: require("@/images/home/1-35.png"),
								txt: "供应链票据到期由票交所统一发起托收，自动到账；签发人有信用准入，回款安全"
							}
						],
						txt: "企业通过供应链平台在票交所的供应链票据系统开具的可等分化签发的电子商业汇票。"
					},
					{
						title: "微贷",
						img: require("@/images/mobile/home/1-11.png"),
						advantage: [{
								num: "特点一",
								tit: "产业服务",
								icon: require("@/images/home/1-37.png"),
								txt: "为核心企业产业链属中小微企业量身定制，产品和服务更懂实体经营"
							},
							{
								num: "特点二",
								tit: "全线上化",
								icon: require("@/images/home/1-40.png"),
								txt: "全流程纯线上化操作"
							},
							{
								num: "特点三",
								tit: "简单方便",
								icon: require("@/images/home/1-39.png"),
								txt: "两项资料，十分钟完成申请，平均三小时到账"
							},
							{
								num: "特点四",
								tit: "灵活好用",
								icon: require("@/images/home/1-38.png"),
								txt: "随借随还，按天计息，不用款零费用"
							}
						],
						txt: "微贷是简单汇基于产业知识图谱，深入分析产业机会，通过整合产业信息（IND）、小微企业信息（B）、企业主个人信息（C），发掘产业链上中小微企业自身的商业信用和金融信用能力，通过向中小微企业提供无抵押的纯信用线上融资服务，助力产业链协同发展。"
					},
					{
						title: "信用评级",
						img: require("@/images/mobile/product/pj-1.png"),
						advantage: [{
								num: "特点一",
								tit: "实力雄厚",
								icon: require("@/images/mobile/product/pj-2.png"),
								txt: "简单汇子公司广东恒诚信用管理有限公司于2014年成立，是向人行备案的全国55家有资质开展信用评级公司之一，也是简单汇产品服务的重要版块。"
							},
							{
								num: "特点二",
								tit: "场景丰富",
								icon: require("@/images/mobile/product/pj-3.png"),
								txt: "产品应用场景覆盖招投标、供应商准入、商业赊销、银行、小贷、保理、融租等金融机构企业授信，在全国主要地区均可线下或全线上手段开展各类评级。"
							},
							{
								num: "特点三",
								tit: "科技加成",
								icon: require("@/images/mobile/product/pj-4.png"),
								txt: "团队拥有专业的分析师队伍及大数据研发人员，形成了科学智能的评级体系，通过数据服务、风控模型提供综合解决方案。"
							},
							{
								num: "特点四",
								tit: "高质高效",
								icon: require("@/images/mobile/product/pj-5.png"),
								txt: "团队拥有多年从业经验及各类成功的案例，能够以专业、高质、高效的方式为中小微企业提供优质评级服务。"
							}
						],
						txt: "恒诚信用评级业务是通过收集企业主体或金融产品的各类信息，依据不断优化的评级方法和模型，评价企业主体或债务的偿债能力和偿债意愿，用信用评级报告的形式发布评级结果。"
					},
					{
						title: "票据秒融",
						img: require("@/images/mobile/product/pjmr-1.png"),
						advantage: [{
								num: "特点一",
								tit: "秒级放款",
								icon: require("@/images/mobile/product/pjmr-2.png"),
								txt: "一键询价，系统自动审批放款，真正实现秒级到账。"
							},
							{
								num: "特点二",
								tit: "全程线上",
								icon: require("@/images/mobile/product/pjmr-3.png"),
								txt: "全流程线上操作，无需线下跑银行开户，高效便捷。"
							},
							{
								num: "特点三",
								tit: "免费询价",
								icon: require("@/images/mobile/product/pjmr-4.png"),
								txt: "多家银行系统对接，报价实时更新，支持 OCR 识票并免费报询价。"
							},
							{
								num: "特点四",
								tit: "节省成本",
								icon: require("@/images/mobile/product/pjmr-5.png"),
								txt: "多家银行，同时询价，择优贴现，节省时间和经济成本。"
							}
						],
						txt: "持票企业可向银行发起线上签约、票据询价、预贴现或预质押等票据业务申请。"
					},
					{
						title: "汇科云",
						img: require("@/images/mobile/product/hky-1.png"),
						advantage: [{
								num: "特点一",
								tit: "模式多样",
								icon: require("@/images/mobile/product/hky-2.png"),
								txt: "品牌定制、单点登录、开放API、本地部署。"
							},
							{
								num: "特点二",
								tit: "产品丰富",
								icon: require("@/images/mobile/product/hky-3.png"),
								txt: "电子债权凭证系统、保理系统、供应链票据系统。"
							},
							{
								num: "特点三",
								tit: "开放共享",
								icon: require("@/images/mobile/product/hky-4.png"),
								txt: "资金方、中登网、第三方服务等优质资源共享。"
							},
							{
								num: "特点四",
								tit: "科技加持",
								icon: require("@/images/mobile/product/hky-5.png"),
								txt: "利用云计算、大数据、区块链、OCR、NLP、RPA、等技术打造的科技赋能产品。"
							}
						],
						txt: "汇科云是科技赋能产品，为客户提供全方位供应链金融科技服务，帮助企业构建“科技+金融”的能力，为客户实现供应链金融与科技的生态融合。"
					},
				],
			},
			//简单汇平台优势
			platform: {
				title: '简单汇平台优势',
				details: '查看详情',
				platformList: [{
						title: "创新发展优势",
						img: require("@/images/home/1-18.png"),
						txt: "从市场首创可流转的应收账款电子债权凭证——金单； 到成为全国第一批直联上海票据交易所的票据基础设施单位，简单汇一直引领行业创新。"
					},
					{
						title: "科技领先优势",
						img: require("@/images/home/1-19.png"),
						txt: "简单汇率先应用区块链技术保障数据安全，成功通过国家高新技术企业认定、CMMI3及国家信息系统安全等级三级认证，不断完成技术升级与突破。"
					},
					{
						title: "产品服务优势",
						img: require("@/images/home/1-20.png"),
						txt: "简单汇致力于提供简单、温暖的客户服务体系，7*24全程专业服务，随时为您答疑解惑，伴随您业务发展的每一步。"
					},
					{
						title: "资金渠道优势",
						img: require("@/images/home/1-21.png"),
						txt: "简单汇首创与银行系统直连模式，先后与十余家全国性大行完成系统直联，并与多家知名财务公司、保理公司保持合作，充分发挥资金渠道优势。"
					},
					{
						title: "专业团队优势",
						img: require("@/images/home/1-22.png"),
						txt: "简单汇管理团队及核心骨干均具备丰富的“金融+科技+产业”行业背景，拥有十余年金融科技或金融行业从业经验，是一支多元化精英团队。"
					}
				],
			}

		},
		english: {
			// 英文的轮播图数组
			carouselListYW: [{
					imagePath: require("@/images/mobile/english/home_carousel_1new.jpg")
				},
				{
					imagePath: require("@/images/mobile/english/home_carousel_2.png")
				},
				{
					imagePath: require("@/images/mobile/english/home_carousel_3.png")
				},
				{
					imagePath: require("@/images/mobile/english/home_carousel_4new.jpg")
				}
			],
			dataConListYW: [
				//新闻数据块数组
				{
					txt: "Registered enterprises",
					img: require("@/images/home/1-3.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Anchor enterprises served",
					img: require("@/images/home/1-5.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Financial institutions served",
					img: require("@/images/home/1-6.png"),
					suffix: "",
					num: 0
				},
				{
					txt: "Sectors served ·Including 100+ secondary sectors",
					img: require("@/images/home/1-4.png"),
					suffix: "",
					num: 0
				}
			],
			//新闻分类
			news: {
				more: 'More',
				slidingListYW: ["Company News", "Media Reports"],
			},
			//产品服务
			product: {
				title: 'Product services',
				productListYW: [{
						title: "JinBill",
						img: require("@/images/mobile/home/1-9.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to circulate",
								icon: require("@/images/home/1-14.png"),
								txt: "Combining actual demands with multiple ways of Golden Bill circulation to optimize cash management and reduce operating costs"
							},
							{
								num: "Feature 2",
								tit: "Splittable",
								icon: require("@/images/home/1-15.png"),
								txt: "Financing split on demand and free of charge"
							},
							{
								num: "Feature 3",
								tit: "Instant financing",
								icon: require("@/images/home/1-16.png"),
								txt: "Online operation in instant response; dispensing with paper documents and withdrawing cash instantaneously"
							},
							{
								num: "Feature 4",
								tit: "Traceable",
								icon: require("@/images/home/1-17.png"),
								txt: "Online access to data reports, and full process traceable"
							}
						],
						txt: "JinBill refers to the creditor’s right certificate for accounts receivable that is easy to circulate, split, finance and trace. Based on the JinBill, the core enterprise promises to grant a certain amount of loans to suppliers on a specified date, through the JDH system by means of electronic signatures."
					},
					{
						title: "Supply Chain Bill",
						img: require("@/images/mobile/home/1-10.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Easy to operate",
								icon: require("@/images/home/1-34.png"),
								txt: "Supply chain bills are easy to split, circulate and finance, with full process accessible online"
							},
							{
								num: "Feature 2",
								tit: "Efficient financing",
								icon: require("@/images/home/1-33.png"),
								txt: "As electronic commercial draft, supply chain bills boast abundant financing channels and high online funding efficiency"
							},
							{
								num: "Feature 3",
								tit: "Cost advantage",
								icon: require("@/images/home/1-36.png"),
								txt: "Zero service fee for supply chain bills receipts, endorsement and maturity processing; lower costs than traditional bill financing"
							},
							{
								num: "Feature 4",
								tit: "Risk control advantage",
								icon: require("@/images/home/1-35.png"),
								txt: "Due supply chain bills are collected by Shanghai Commercial Paper Exchange Corporation Ltd., with direct remittance; trust thresholds are set for issuers to ensure payment return"
							}
						],
						txt: "Supply chain bill refers to the electronic commercial bill issued by enterprises through the supply chain platform in the supply chain bill system of Shanghai Commercial Paper Exchange Corporation Ltd., which can be equally differentiated and issued."
					},
					{
						title: "WiCredit",
						img: require("@/images/mobile/home/1-11.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Industry services",
								icon: require("@/images/home/1-37.png"),
								txt: "Products and services customized for SMEs of the industrial chain of core enterprises; better understanding the real industry operation"
							},
							{
								num: "Feature 2",
								tit: "Full process online",
								icon: require("@/images/home/1-40.png"),
								txt: "Full process accessible online"
							},
							{
								num: "Feature 3",
								tit: "Easy and convenient",
								icon: require("@/images/home/1-39.png"),
								txt: "Two e-documents and ten minutes to complete an application, and only 3 hours on average to receive the fund"
							},
							{
								num: "Feature 4",
								tit: "Flexible and user friendly",
								icon: require("@/images/home/1-38.png"),
								txt: "Flexible to lend and return; interests counted daily; zero service fee if the fund is unused"
							}
						],
						txt: "WiCredit aims to explore the commercial and financial credit capabilities of the micro, small and medium-sized enterprises (MSMEs) in the industrial chain. It is based on the industrial knowledge map, in-depth analysis of industrial opportunities, and integration of industrial data (IND), small and micro enterprises information (B) and business owners' personal information (C). It promotes the coordinated development of the industrial chain by providing online credit financing services to MSMEs without collateral. "
					},
					{
						title: "Credit rating Service",
						img: require("@/images/home/1-60.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Strong Strength ",
								icon: require("@/images/home/1-61.png"),
								txt: "Guangdong Hengcheng Credit Management Co., Ltd., a subsidiary of JDH, was established in 2014. It is one of the 55 qualified credit rating companies in the country that have been registered with the People's Bank of China, and is also an important section of JDH’s products and services."
							},
							{
								num: "Feature 2",
								tit: "Rich Scenarios",
								icon: require("@/images/home/1-62.png"),
								txt: "Product Application Scenarios cover Bidding, Supplier Access, Commercial Credit Sales, Banking, Small Loans, Factoring, Financial Leasing and financial Institution corporate credit. All kinds of ratings can be carried out offline or online in major regions of the country."
							},
							{
								num: "Feature 3",
								tit: "Technical",
								icon: require("@/images/home/1-63.png"),
								txt: "The team has a professional team of analysts and big data R&D personnel, forming a scientific and intelligent rating system, providing comprehensive solutions through data services and risk control models."
							},
							{
								num: "Feature 4",
								tit: "High quality and efficiency",
								icon: require("@/images/home/1-64.png"),
								txt: "The team has many years of experience and various successful cases, and can provide high-quality rating services for SMEs in a professional, high-quality and efficient way."
							}
						],
						txt: "The credit rating business of Hengcheng is to evaluate the solvency and willingness to pay debts of corporate entities or debts based on the continuously optimized rating methods and models, by collecting various information about corporate entities or financial products, and publish the rating results in the form of credit rating reports.The rating results can be widely used for enterprises to apply for various types of financing from financial institutions and various preferential policies of government institutions , and also display credit information to cooperative enterprises."
					},
					{
						title: "Bill financing in seconds",
						img: require("@/images/home/1-55.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Lending in seconds",
								icon: require("@/images/home/1-56.png"),
								txt: "One-click inquiry, the system automatically approves the loan, and truly realizes loan to the account in seconds."
							},
							{
								num: "Feature 2",
								tit: "All online",
								icon: require("@/images/home/1-57.png"),
								txt: "The whole process is operated online, and there is no need to go offline to open a bank account, which is efficient and convenient."
							},
							{
								num: "Feature 3",
								tit: "Free inquiry",
								icon: require("@/images/home/1-58.png"),
								txt: "Docking with multiple banking systems, quotations are updated in real time, OCR bills recognition is supported, and free quotation."
							},
							{
								num: "Feature 4",
								tit: "Save cost",
								icon: require("@/images/home/1-59.png"),
								txt: "Multiple banks can be inquiring at the same time, discounting at the best, saving time and economic costs."
							}
						],
						txt: "Bill-holding companies can initiate bill financing applications such as online signing, bill inquiry, pre-discount or pre-pledge to the bank."
					},
					{
						title: "Huike Cloud",
						img: require("@/images/home/1-50.png"),
						advantage: [{
								num: "Feature 1",
								tit: "Diverse modes",
								icon: require("@/images/home/1-51.png"),
								txt: "Brand customization, single sign-on, open API, local deployment."
							},
							{
								num: "Feature 2",
								tit: "Rich products",
								icon: require("@/images/home/1-52.png"),
								txt: "Creditor's rights electronic voucher system, factoring system, supply chain bill system."
							},
							{
								num: "Feature 3",
								tit: "Open and Shared",
								icon: require("@/images/home/1-53.png"),
								txt: "Sharing of high-quality resources such as funders, Zhongdengwang and third-party services."
							},
							{
								num: "Feature 4",
								tit: "Technology blessing",
								icon: require("@/images/home/1-54.png"),
								txt: "Technology-enabled products using cloud computing, big data, block chain, OCR, NLP, RPA and other technologies."
							}
						],
						txt: `Huike Cloud is a technology-enabled product that provides customers with a full range of supply chain financial technology services, helps companies build "Technology + Finance" capabilities, and realizes the ecological integration of supply chain finance and technology for customers.`
					}
				],
			},
			platform: {
				title: 'Advantages of the JDH platform',
				details: 'View details',
				platformListYW: [{
						title: "Advantages of innovative development",
						img: require("@/images/home/1-18.png"),
						txt: "JDH has been leading the industry innovation from creating the first circulated electronic creditor’s right certificate for accounts receivable on the market – JinBill to becoming one of the first batch of bill infrastructure units directly connected to Shanghai Commercial Paper Exchange Corporation Ltd. in China."
					},
					{
						title: "Advantages of science and technology",
						img: require("@/images/home/1-19.png"),
						txt: "Having first applied blockchain technology to ensure data security, JDH has obtained the national high-tech enterprise certification as well as Level 3 certifications of Capability Maturity Model Integration (CMMI) and Level 3 certification of national information system security. JDH has been continuously pursuing technological upgrading and breakthroughs."
					},
					{
						title: "Advantages of services",
						img: require("@/images/home/1-20.png"),
						txt: "JDH is committed to providing a simple and warm customer service system where 7*24 professional services are provided to respond to your enquires. We will support you in every step of your business development."
					},
					{
						title: "Advantages of capital channels",
						img: require("@/images/home/1-21.png"),
						txt: "JDH first creates the model of direct connection with the banking systems. It has successively completed the direct connection with over ten national banks, and maintained cooperation with many well-known financial companies and factoring companies, thus giving full play to its advantages of capital channels."
					},
					{
						title: "Advantages of the professional team",
						img: require("@/images/home/1-22.png"),
						txt: "Making itself a diversified elite team, JDH management team as well as its core members boasts strong industry background of “finance + technology + industry” and rich working experience over ten years in financial technology or financial sector."
					}
				],
			}

		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/lang/home.js